
/* injects from baggage-loader */

'use strict';

import transtionZoomController from './transition-zoom.controller';

const transtionZoomModule = angular.module('transition-zoom-module', []);

transtionZoomModule
    .component('transitionZoom', {
        controller: transtionZoomController
    });

export default transtionZoomModule;



// WEBPACK FOOTER //
// ./src/app/components/ui/transition-zoom/transition-zoom.module.js